import 'styles/globals.scss'

const back = document.querySelector('.back') as HTMLButtonElement

back?.addEventListener('click', (e) => {
  if (!e.target?.dataset.route) return
  window.location.href = e.target.dataset.route
})
